import api from "./baseApi";
import endpoints from "./endpoints";

// =============================
// Get all settings
// =============================
export const getSettings = async () => {
  try {
    const res = await api.get(endpoints.settings.base);
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to fetch settings";

    throw new Error(message);
  }
};

// =============================
// Update single setting (by item)
// Supports:
// - JSON payload
// - FormData (for file upload)
// =============================
export const updateSetting = async (payload) => {
  try {
    let config = {};

    let dataToSend = payload;

    // If payload is FormData → ensure correct headers
    if (payload instanceof FormData) {
      config.headers = {
        "Content-Type": "multipart/form-data",
      };
      dataToSend = payload;
    }

    const res = await api.put(
      endpoints.settings.base,
      dataToSend,
      config
    );

    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to update setting";

    throw new Error(message);
  }
};

// =============================
// Upload Image
// =============================
export const uploadImage = async (file, folder = "general") => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("folder", folder);

    const res = await api.post(
      endpoints.settings.upload,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return res.data; // { path, url }
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to upload image";

    throw new Error(message);
  }
};

// =============================
// Delete Receipt Logo
// =============================
export const deleteReceiptLogo = async () => {
  try {
    const res = await api.delete(endpoints.settings.deleteReceiptLogo);
    return res.data;
  } catch (err) {
    const message =
      err.response?.data?.message || "failed to delete receipt logo";

    throw new Error(message);
  }
};